export default __webpack_public_path__ + "static/media/preppysport_thumbnail.5554fec4.png";